import { useAuth } from "@cavort/auth";
import { useCallback } from "react";

/// Coarse-grained permission check.
///
/// After the cavort-auth migration the Burresi custom per-module permission
/// system is retired in favour of cavort-auth's three-tier role
/// (`owner` | `admin` | `member`). The signature is kept so call sites
/// don't have to change, but the implementation now only differentiates
/// admin/owner from member.
///
/// - `owner` and `admin`: full access (every `can()` returns true).
/// - `member`: read-only by convention; mutating actions return false.
///
/// `module` is ignored. `action` is interpreted as "any of {view, read,
/// list}" = read, anything else = mutating.
export function usePermissions() {
	const { user } = useAuth();

	const can = useCallback(
		(_module: string, action: string): boolean => {
			if (!user) return false;
			if (user.role === "owner" || user.role === "admin") return true;
			// Members can read but not mutate.
			return action === "view" || action === "read" || action === "list";
		},
		[user],
	);

	return { can };
}
